import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        const quickLook = document.querySelector("#permissions-quick-look")
        if (quickLook) {
            quickLook.addEventListener("change", this.handleCheckboxChange.bind(this))
        }
    }

    handleCheckboxChange(event) {
        const checkbox = event.target
        if (checkbox.type !== "checkbox") return

        if (checkbox.name === "permissions[]" && !checkbox.checked) {
            const selectAll = document.querySelector("#select_all_permissions")
            if (selectAll) selectAll.checked = false
        }

        if (checkbox.hasAttribute("data-instructor-dashboard-checkbox")) return

        if (checkbox.checked && checkbox.hasAttribute("data-view-classroom-sessions-checkbox")) {
            const instructorDashboard = document.querySelector("[data-instructor-dashboard-checkbox]")
            if (instructorDashboard) instructorDashboard.checked = true
            return
        }
    }

    toggleAll(event) {
        const checked = event.target.checked
        this.element
            .querySelectorAll('input[name="permissions[]"], #is_admin, #purchase_confirmation_emails')
            .forEach((cb) => {
                if (!cb.disabled) cb.checked = checked
            })
    }

    async showQuicklook(event) {
        event.preventDefault()
        const memberId = event.currentTarget.dataset.id
        const url = `/schools/setup/roles-permissions/quick-look?member_id=${memberId}`

        console.log("showQuicklook called with memberId:", memberId)

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    Accept: "text/vnd.turbo-stream.html"
                }
            })


            if (response.ok) {
                const quickLookElement = document.querySelector("#permissions-quick-look")
                quickLookElement.innerHTML = await response.text()
                quickLookElement.classList.remove("u-hidden")
            } else {
                console.error("Error fetching quick look data:", response)
            }
        } catch (error) {
            console.error("Error fetching quick look data:", error)
        }
    }

    async closeQuicklook(event) {
        event.preventDefault()
        const quickLookElement = document.querySelector("#permissions-quick-look")
        console.log(quickLookElement)
        quickLookElement.classList.add("u-hidden")
    }
}